"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrezlyThemeDocument = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const theme_kit_core_1 = require("@prezly/theme-kit-core");
const document_1 = __importStar(require("next/document"));
class PrezlyThemeDocument extends document_1.default {
    getLocaleCode() {
        const { newsroomContextProps,
        // eslint-disable-next-line no-underscore-dangle
         } = this.props.__NEXT_DATA__.props.pageProps;
        // In some cases (like server errors) the newsroom context props will not be loaded.
        // We need to fall back to default locale to keep the app working.
        const { localeCode } = newsroomContextProps ?? { localeCode: theme_kit_core_1.DEFAULT_LOCALE };
        return localeCode;
    }
    render() {
        const locale = theme_kit_core_1.LocaleObject.fromAnyCode(this.getLocaleCode());
        // TODO: The direction can be pulled from the Language object
        const direction = (0, theme_kit_core_1.getLocaleDirection)(locale);
        return ((0, jsx_runtime_1.jsxs)(document_1.Html, { lang: locale.toHyphenCode(), dir: direction, children: [(0, jsx_runtime_1.jsx)(document_1.Head, { children: (0, jsx_runtime_1.jsx)("meta", { name: "og:locale", content: locale.toHyphenCode() }) }), (0, jsx_runtime_1.jsxs)("body", { children: [(0, jsx_runtime_1.jsx)(document_1.Main, {}), (0, jsx_runtime_1.jsx)(document_1.NextScript, {})] })] }));
    }
}
exports.PrezlyThemeDocument = PrezlyThemeDocument;
//# sourceMappingURL=document.js.map